import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  CardActions,
  // useMediaQuery,
} from "@mui/material";
import StrikePriceIcon from "@mui/icons-material/TrendingUp";
import MultiOpenInterestIcon from "@mui/icons-material/BarChart";
import TradersRoomIcon from "@mui/icons-material/AccountBalance";

import bgimg from "assets/dashboard/Lines.svg"
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function FeaturesBox() {

  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
 const handleNavigation = (option, path) => {
  localStorage.setItem("page", option);
  window.location.href = path;
};
  return (
    <Box marginTop={16}  textAlign="center">
      <Grid container  style={{display:"flex", justifyContent:"space-around", }} >
        
        <Grid item xs={12} md={3} sm={12} style={{ background: "rgba(218, 218, 218, 0.6)", padding:"1rem", border: '0.2rem solid rgb(208, 210, 217)', borderRadius:"1rem", display:"flex", justifyContent:"center", alignContent:"center", marginBottom:(smDown)?"3rem":"0rem"}}>
        <Card  style={{backgroundColor: "#fff", boxShadow:"none", display:"inline", justifyContent:"center", alignContent:"center"}}>
            <CardContent>
              <StrikePriceIcon fontSize="large" style={{color:"#000", fontWeight:"600"}} />
              <Typography variant="h6" gutterBottom style={{color:"#000", fontWeight:"600"}}>
              Option Chain
              </Typography>
              <Typography variant="subtitle1" color="textSecondary" style={{color:"rgb(176, 184, 196)"}}>
                An option chain data at one place. Identifiy support and resistances.
              </Typography>
            </CardContent>
            <CardActions>
              <Button size="large" color="primary" style={{color:"#000", fontWeight:"600", fontSize:"14px"}}  onClick={() => handleNavigation("oc", "/OptionChain")}>
                Open →
              </Button>
            </CardActions>

          </Card>
        </Grid>

        <Grid item xs={12} md={3} sm={12} style={{ background: "rgba(218, 218, 218, 0.6)", padding:"1rem", border: '0.2rem solid rgb(208, 210, 217)', borderRadius:"1rem", display:"flex", justifyContent:"center", alignContent:"center", marginBottom:(smDown)?"3rem":"0rem" }}>
        <Card  style={{backgroundColor: "#fff", boxShadow:"none", display:"inline", justifyContent:"center", alignContent:"center"}}>
            <CardContent>
              <StrikePriceIcon fontSize="large" style={{color:"#000", fontWeight:"600"}} />
              <Typography variant="h6" gutterBottom style={{color:"#000", fontWeight:"600"}}>
              Multi Strike OI
              </Typography>
              <Typography variant="subtitle1" color="textSecondary" style={{color:"rgb(176, 184, 196)"}}>
              Graph of OI buildup in each strike. See the battle between calls and puts.
              </Typography>
            </CardContent>
            <CardActions>
            <Button size="large" color="primary" style={{color:"#000", fontWeight:"600", fontSize:"14px"}}  onClick={() => handleNavigation("mo", "/MultiOI")}>
                Open →
              </Button>
            </CardActions>

          </Card>
        </Grid>

        <Grid item xs={12} md={3} sm={12} style={{ background: "rgba(218, 218, 218, 0.6)", padding:"1rem", border: '0.2rem solid rgb(208, 210, 217)', borderRadius:"1rem", display:"flex", justifyContent:"center", alignContent:"center" }}>
        <Card  style={{backgroundColor: "#fff", boxShadow:"none", display:"inline", justifyContent:"center", alignContent:"center"}}>
            <CardContent>
              <StrikePriceIcon fontSize="large" style={{color:"#000", fontWeight:"600"}} />
              <Typography variant="h6" gutterBottom style={{color:"#000", fontWeight:"600"}}>
              Traders Room
              </Typography>
              <Typography variant="subtitle1" color="textSecondary" style={{color:"rgb(176, 184, 196)"}}>
              One stop solution of your trading analysis. All charts at one place
              </Typography>
            </CardContent>
            <CardActions>
            <Button size="large" color="primary" style={{color:"#000", fontWeight:"600", fontSize:"14px"}} onClick={() => handleNavigation("tr", "/TradersRoom")}>
                Open →
              </Button>
            </CardActions>

          </Card>
        </Grid>

      </Grid>
      {/* <Button variant="contained" color="primary">
        Go to Instant Chart
      </Button> */}
    </Box>
  );
}

export default FeaturesBox;
